import { curry, pipe } from 'rambda';
import setMenubarData from 'services/decorator/menubar/menubarData';
import menubarConnnector from 'services/connect/menuBarConnector';
import leftNavConnnector from 'services/connect/leftNavConnector';
import constants from 'constants/actions';
import utils from '../app/utils';
import { localStorageCacheDecorator } from '../app/cacheHelper';

const then = curry((f, p) => p.then(f));

const getMenubarDataHandler = pipe(menubarConnnector, then(setMenubarData));
const cachedGetMenubarDataHandler = (args) => localStorageCacheDecorator({ func: getMenubarDataHandler, options: { storageKey: `${utils.isB2cClient() ? 'MENUBAR_CACHE_B2C' : 'MENUBAR_CACHE'}`, cacheTimeConfigKey: 'menubarCaching' }, args });

export const getMenubarData = (args) => {
    return async (dispatch) => {
        const response = await cachedGetMenubarDataHandler(args);
        const { payload = {} } = response;
        dispatch({
            type: constants.MENUBAR.GET_MENUBAR,
            payload
        });
    };
}

const getLeftNavDataHandler = pipe(leftNavConnnector, then(setMenubarData));
const cachedGetLeftNavDataHandler = (args) => localStorageCacheDecorator({ func: getLeftNavDataHandler, options: { storageKey: 'LEFTNAV_CACHE', cacheTimeConfigKey: 'leftnavCaching' }, args });

export const getLeftNavData = () => {
    return async (dispatch) => {
        const response = await cachedGetLeftNavDataHandler();
        const { payload = {} } = response;
        dispatch({
            type: constants.MENUBAR.GET_LEFTNAV,
            payload
        });
    }
};
